import { PageScreen, SearchKey } from "../../types/search";
import { SelectOption } from "../../types/select";
import { useBusinessUnitOptions } from "./useBusinessUnitOptions";
import { usePropertyAdminOptions } from "./usePropertyAdminOptions";
import { usePropertyOwnersOptions } from "./usePropertyOwnersOptions";

type SelectSearchByKey = Extract<SearchKey, "propertyAdmin" | "businessUnitId" | "ownerName">;

type UseBusinessUnitOptions = {
  screen?: PageScreen;
  selectedSearchBy?: string;
};

export const useSelectOptions = (options: UseBusinessUnitOptions) => {
  const { screen, selectedSearchBy } = options;

  const isSelectByKey = (key: string): key is SelectSearchByKey => {
    return key === "propertyAdmin" || key === "businessUnitId" || key === "ownerName";
  };

  const typedSearchByKey = isSelectByKey(selectedSearchBy ?? "") ? selectedSearchBy : undefined;

  const { propertyAdminOptions } = usePropertyAdminOptions({
    isEnabled: typedSearchByKey === "propertyAdmin",
  });

  const { businessUnitOptions } = useBusinessUnitOptions({
    isEnabled: typedSearchByKey === "businessUnitId",
  });

  const { propertyOwnersOptions } = usePropertyOwnersOptions({
    screen,
    isEnabled: typedSearchByKey === "ownerName",
  });

  const selectOptionsMap: Record<SelectSearchByKey, unknown[]> = {
    propertyAdmin: propertyAdminOptions,
    businessUnitId: businessUnitOptions,
    ownerName: propertyOwnersOptions,
  };

  const selectOptions: SelectOption[] = typedSearchByKey ? selectOptionsMap[typedSearchByKey] : [];

  return { selectOptions };
};
